import { RegionIdMap } from '@/types/region'

export const DEFAULT_REGION_CODE = 'HK'
export const DEFAULT_REGION_ID = RegionIdMap.EATIGO_HONG_KONG
